import React from "react";
import image from "../../Assets/Images/About.png";

const Hero = () => {
  return (
    <div className="mx-auto px-6 lg:px-14 py-16 flex flex-col lg:flex-row items-center gap-12">
      <div className="relative w-full lg:w-1/2">
        <div className="absolute -left-2 -bottom-2 md:-bottom-4 md:-left-4 w-full h-full bg-primaryColor rounded-xl -z-10"></div>
        <img
          src={image}
          alt="INSD Mentorship"
          className="w-full h-auto rounded-xl object-cover"
        />
      </div>

      <div className="flex-1 space-y-6 text-left">
        <h2 className="text-5xl font-bold font-barlow leading-tight heading">
          Nurturing Creative Minds for a Global Design Future
        </h2>
        <p className="text-gray-600 text-lg leading-relaxed sub-heading ">
          At{" "}
          <span className="font-extrabold">
            INSD – International School of Design
          </span>
          , we believe that every creative idea deserves expert guidance. Our
          mentors — top designers, artists, and industry professionals — ensure
          that students gain the skills, confidence, and exposure they need to
          excel in the world of design.
        </p>

        <ul className="space-y-7 text-base md:text-lg text-gray-700 sub-heading">
          <li className="flex items-center gap-3 ">
            <div className="bg-black w-4 h-4 rounded-sm">
              <span className="w-4 h-4 bg-primaryColor -translate-y-1 -translate-x-1 rounded-sm block"></span>
            </div>
            Learn directly from award-winning designers and creative
            professionals
          </li>
          <li className="flex items-center gap-3">
            <div className="bg-black w-4 h-4 rounded-sm">
              <span className="w-4 h-4 bg-primaryColor -translate-y-1 -translate-x-1 rounded-sm block"></span>
            </div>
            Gain real-world experience through live industry projects and
            workshops
          </li>
          <li className="flex items-center gap-3">
            <div className="bg-black w-4 h-4 rounded-sm">
              <span className="w-4 h-4 bg-primaryColor -translate-y-1 -translate-x-1 rounded-sm block"></span>
            </div>
            Access mentorship and career guidance from leading fashion & design
            experts
          </li>
        </ul>

        {/* <button className="relative w-1/2 md:w-1/3 bg-gradient-to-r from-primaryColor to-secondaryColor text-white font-bold rounded-xl py-4 overflow-hidden group transition-all duration-300">
          <span className="block transition-transform duration-500 ease-in-out group-hover:-translate-y-10">
            Our Mentors
          </span>
          <span className="absolute inset-0 flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
            Our Mentors
          </span>
        </button> */}
      </div>
    </div>
  );
};

export default Hero;
